// extracted by mini-css-extract-plugin
export var labelWrapper = "_gx-0";